export default function qrCodeBackButton(param, dispatch) {

    if (param) {
       const { scannerQr,scannerQrState, PostazioneScannedQrCode, PostazioneScannedQrCodeState  } = param;
       if(scannerQrState) return scannerQr(false)
       if(PostazioneScannedQrCodeState) return PostazioneScannedQrCode(false)
    }
  }